import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { ChannelFormValues } from 'src/models/Channel.model';
import ChannelForm from '../Layouts/ChannelForm';
import { useAddChannelMutation } from 'src/services/ChannelServices';
import { showToast } from 'src/utils/showToaster';

type Props = {
    onClose: () => void;
};

const AddChannelFormWrapper = ({ onClose }: Props) => {
    const [addChannel] = useAddChannelMutation();

    // Form Initial Values
    const initialValues: ChannelFormValues = {
        channelName: '',
    };

    // Validation Schema
    const validationSchema = object().shape({
        channelName: string().required('Please enter name'),

    });

    // Handle Submit
    const handleSubmit = (
        values: ChannelFormValues,
        { setSubmitting, resetForm }: FormikHelpers<ChannelFormValues>
    ) => {
        addChannel({
            channelName: values?.channelName,
        }).then((res: any) => {
            if ("data" in res) {
                if (res?.data?.status) {
                    showToast("success", "added successfully!");
                    onClose();
                    resetForm()
                } else {
                    showToast("error", res?.data?.message);
                }
            } else {
                showToast("error", "Something went wrong");
            }
            setSubmitting(false)
        });
    };

    return (
        <Dialog open maxWidth='xs' fullWidth>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formikProps) => (
                    <Form>
                        <ChannelForm formType='Add' formikProps={formikProps} onClose={onClose} />
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default AddChannelFormWrapper;